import { useLazyFetchZipcodeLocationQuery } from '@ee-api/zipcode-api/zipcodeService';

type useFetchZipcodeLocationReturn = {
    fetchZipcodeLocation: ReturnType<typeof useLazyFetchZipcodeLocationQuery>[0];
};

/**
 * Hook that returns a function for looking up the city/state for a given zipcode.
 */
const useFetchZipcodeLocation = (): useFetchZipcodeLocationReturn => {
    const [lazyFetchZipcodeLocationQuery] = useLazyFetchZipcodeLocationQuery();

    const fetchZipcodeLocation = (zipcode: string, preferCacheValue = true) => {
        const cleanZipcode = zipcode.replace(/\D/g, '').substring(0, 5);
        return lazyFetchZipcodeLocationQuery(cleanZipcode, preferCacheValue);
    };

    return {
        fetchZipcodeLocation,
    };
};

export default useFetchZipcodeLocation;
